// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__1Oaxj","table":"Market_table__2xNnv","row":"Market_row__1plLv","col":"Market_col__tK6c0","foot":"Market_foot__3byxZ","arrow":"Market_arrow__1PeTJ"};